import { render, staticRenderFns } from "./CosmoteInsertCodeRoute.vue?vue&type=template&id=60b7ca2e&scoped=true&"
import script from "./CosmoteInsertCodeRoute.vue?vue&type=script&lang=js&"
export * from "./CosmoteInsertCodeRoute.vue?vue&type=script&lang=js&"
import style0 from "./CosmoteInsertCodeRoute.vue?vue&type=style&index=0&id=60b7ca2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b7ca2e",
  null
  
)

export default component.exports